import '../domain/dtos/alert-type.js';
import '../domain/dtos/error-type.js';
import '../domain/dtos/main-content-type.js';
import '../domain/dtos/post-event-type.js';
import { PostStatus } from '../domain/dtos/post-status.js';
import '../domain/dtos/query-key.js';
import '../domain/dtos/remove-dialog-action.js';

const makePostSubmittedData = data => ({
  hasAttachment: data.attachments && data.attachments.length > 0 ? true : false,
  userId: data.userId,
  productId: data.productId,
  postStatus: data.isUpdatePost ? PostStatus.DRAFT : PostStatus.PUBLISHED,
  hasMainContent: data.mainMediaProgressStatus.length > 0 ? true : false,
  mainContentType: data.mainContentType,
  hasSubtitle: data.subtitle !== '' ? true : false,
  hasBodyContent: data.content !== '' ? true : false
});

export { makePostSubmittedData };
